var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5155714_2672290 1",
    clipPath: "url(#clip0_178_9158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M64.7912 71.7257C60.1802 54.9986 39.4013 49.6103 27.4934 62.1113C27.3224 62.2907 27.1517 62.4734 26.9807 62.6588C9.9086 81.2168 17.9735 126.95 53.6027 138.541C89.2319 150.132 126.291 128.965 128.373 110.044C130.455 91.1222 114.017 85.1768 88.5083 90.4676C74.0957 93.4568 67.6616 82.1387 64.7912 71.7257Z",
    fill: "#E0D5F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M94.4297 74.5868C89.6627 75.3629 88.3415 79.5862 92.0222 82.5823C93.2387 83.5726 94.9763 84.3955 97.4513 84.8059C106.88 86.3701 111.883 82.1986 108.104 76.7899C105.772 73.4519 99.1541 73.8176 94.4297 74.5868Z",
    fill: "#E0D5F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.6539 108.771C18.313 104.546 13.8916 104.73 12.315 109.206C11.7939 110.685 11.6064 112.599 12.0561 115.067C13.7689 124.469 19.3855 127.769 23.1994 122.385C25.5535 119.062 22.9738 112.958 20.6539 108.771Z",
    fill: "#E0D5F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M131.733 112.243C131.293 114.542 133.192 116.17 135.343 115.284C136.054 114.991 136.771 114.427 137.409 113.434C139.839 109.654 138.608 106.411 135.225 106.744C133.136 106.949 132.168 109.965 131.733 112.243Z",
    fill: "#E0D5F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M119.682 87.9832C121.973 88.4614 123.633 86.5912 122.784 84.4255C122.503 83.7097 121.951 82.9831 120.97 82.3282C117.231 79.8341 113.968 81.0095 114.243 84.3982C114.413 86.4901 117.411 87.5095 119.682 87.9832Z",
    fill: "#E0D5F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M63.9949 63.3826C65.809 64.8616 68.144 63.9652 68.3867 61.6516C68.4671 60.8869 68.3111 59.9875 67.7411 58.9546C65.5696 55.0195 62.1313 54.5614 60.8161 57.6967C60.0043 59.6323 62.1973 61.9171 63.9949 63.3826Z",
    fill: "#E0D5F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M136.542 145.941C137.329 146.072 138.149 145.852 138.697 145.272C139.055 144.895 139.297 144.428 139.297 143.981C139.297 143.975 139.297 143.968 139.297 143.962C139.287 140.755 143.227 140.969 144.491 137.048C145.756 133.127 140.758 132.797 137.903 135.218C135.85 136.958 133.387 134.527 130.403 136.557C127.812 138.319 129.255 142.657 125.006 141.301C123.649 140.867 122.434 141.285 121.408 142.055C120.228 142.941 119.459 144.182 119.139 145.531L119.478 145.77C127.859 150.907 131.636 145.122 136.542 145.941Z",
    fill: "#9C78ED"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M128.237 145.77L139.348 138.637C139.497 138.542 139.54 138.344 139.444 138.195C139.349 138.046 139.151 138.003 139.002 138.099L127.052 145.77L128.237 145.77Z",
    fill: "#7846D1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M127.639 124.55C127.17 117.56 127.093 110.229 127.613 105.368C128.293 99.0181 129.83 94.5976 132.183 92.2301C132.339 92.0732 132.593 92.0723 132.75 92.2283C132.907 92.3843 132.908 92.6381 132.752 92.795C128.638 96.934 127.159 108.048 128.466 124.958L127.639 124.55Z",
    fill: "#5B23A9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M128.69 99.7582C128.69 99.7582 125.341 99.7528 125.581 93.8647C125.581 93.8647 130.705 95.3266 128.69 99.7582Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M128.41 102.787C128.41 102.787 128.229 99.4427 134.121 99.3542C134.121 99.3542 132.946 104.552 128.41 102.787Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M130.971 94.528C130.971 94.528 129.685 91.4353 135.211 89.3872C135.211 89.3872 135.837 94.6795 130.971 94.528Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M127.658 108.864C127.658 108.864 124.504 109.992 122.738 104.37C122.738 104.37 128.055 104.013 127.658 108.864Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M127.839 111.994C127.839 111.994 127.083 108.731 132.871 107.625C132.871 107.625 132.612 112.947 127.839 111.994Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M127.662 116.303C127.662 116.303 124.53 117.49 122.658 111.903C122.658 111.903 127.967 111.445 127.662 116.303Z",
    fill: "#7846D1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M30.4692 140.131L29.5566 140.095L29.0727 140.075L27.7017 140.021C27.7017 140.021 15.0302 118.509 22.9682 111.494C25.4121 109.334 29.6844 111.125 28.74 121.051C27.8646 130.252 30.4692 140.131 30.4692 140.131Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M29.5564 140.095L29.0725 140.075C26.8603 134.863 25.7437 129.264 25.1893 125.334C24.5311 120.668 24.5005 117.279 24.5005 117.246C24.4993 117.125 24.5968 117.026 24.7177 117.026C24.8386 117.024 24.9376 117.122 24.9382 117.243C24.9385 117.276 24.9685 120.641 25.624 125.28C26.1817 129.23 27.3103 134.874 29.5564 140.095Z",
    fill: "#5B23A9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M32.9865 144.441L31.7472 144.901L31.0896 145.145L29.2268 145.835C29.2268 145.835 0.308146 124.151 7.00689 110.355C9.06911 106.107 15.7757 106.119 20.0444 119.909C24.0017 132.691 32.9865 144.441 32.9865 144.441Z",
    fill: "#9C78ED"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M31.7472 144.901L31.0896 145.145C25.2294 139.413 20.6174 132.553 17.687 127.611C14.2073 121.742 12.2783 117.232 12.26 117.187C12.191 117.026 12.2663 116.839 12.4274 116.771C12.5885 116.702 12.7748 116.778 12.8429 116.938C12.8621 116.984 14.7773 121.463 18.2378 127.297C21.1835 132.263 25.8369 139.177 31.7472 144.901Z",
    fill: "#7846D1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M131.835 145.668C131.82 145.168 131.762 144.663 131.652 144.162C130.612 139.403 133.441 138.505 137.17 137.002C140.898 135.499 141.342 131.034 138.702 127.324C136.061 123.613 140.806 120.63 139.059 115.046C137.311 109.461 131.244 113.176 129.916 118.324C128.962 122.026 124.111 121.225 122.315 126.026C120.754 130.193 125.984 134.042 119.944 135.952C118.014 136.561 116.948 138.042 116.389 139.775C115.746 141.771 115.873 143.841 116.607 145.667L131.835 145.668Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M124.446 145.668L134.396 121.106C134.49 120.873 134.378 120.608 134.145 120.514C133.912 120.42 133.647 120.532 133.553 120.765L123.465 145.668L124.446 145.668Z",
    fill: "#5B23A9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M41.546 71.4109C41.546 71.4109 41.7551 66.9889 39.0656 66.1396C34.8776 64.8169 33.7118 66.9889 33.0656 68.4241C32.2372 70.2634 32.5904 73.8712 35.0891 74.2195C38.8193 74.7397 41.3156 72.6466 41.546 71.4109Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M44.2455 86.1982C46.422 86.1982 48.3022 84.673 48.748 82.5424C49.069 81.0079 49.3825 79.6495 49.3825 78.8863L49.3825 78.8665C49.402 78.6253 49.4128 78.3841 49.4146 78.1465C49.4431 74.6573 47.292 68.2844 39.7254 69.2972C39.7254 69.2972 33.447 70.0136 32.7323 76.1488C32.7323 76.1488 32.4347 78.9793 32.237 81.0289C32.2334 81.0652 32.2298 81.1012 32.2262 81.1369C31.9502 83.8459 34.0806 86.1976 36.8034 86.1976L44.2455 86.1976L44.2455 86.1982Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M53.2285 93.491C53.2285 93.491 54.5665 104.09 56.0948 109.532C56.0948 109.532 58.2662 108.52 61.1081 107.147C64.1897 105.659 68.6198 102.942 68.6198 102.942L69.7394 105.639C69.7394 105.639 58.2959 116.44 54.5053 117.051C50.7148 117.663 48.3916 104.09 48.3916 104.09L53.2285 93.491Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M68.3853 103.259C68.3853 103.259 68.0709 101.753 68.7447 100.734C69.4185 99.7144 70.4445 97.8064 71.649 97.408C72.657 97.0747 71.1699 98.776 71.1255 99.8554C71.1255 99.8554 72.6246 99.6673 73.7058 99.316C74.6568 99.007 76.5387 98.6215 77.4114 98.4499C77.6505 98.4028 77.8041 98.7043 77.6199 98.8639C77.3223 99.1219 76.7004 99.4462 75.4143 99.7561C75.4143 99.7561 78.549 99.1627 78.8742 99.6427C79.1994 100.123 75.2667 100.793 75.2667 100.793C75.2667 100.793 78.318 100.612 78.3975 101.091C78.4458 101.382 75.2847 102.05 75.2847 102.05C75.2847 102.05 78.1695 102.127 77.4717 102.583C77.2686 102.715 71.6838 103.344 69.7395 105.639C69.7395 105.639 68.4315 104.288 68.3853 103.259Z",
    fill: "#FFA681"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M33.9325 91.4031C33.9325 91.4031 27.5304 93.2913 22.017 94.5351C22.017 94.5351 21.8739 92.1441 21.7296 88.9911C21.573 85.5723 21.8547 80.3835 21.8547 80.3835L18.9498 80.6817C18.9498 80.6817 14.8934 95.8854 16.1586 99.5102C17.424 103.135 33.4915 98.0573 33.4915 98.0573L33.9325 91.4031Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M21.6884 80.7406C21.6884 80.7406 23.1626 80.3008 23.7383 79.2232C24.3143 78.1456 25.9052 75.9758 24.9233 75.1724C24.5648 74.879 24.3065 76.1588 23.378 76.7114C23.378 76.7114 22.8305 75.3035 22.625 74.1851C22.4441 73.2014 21.8882 71.363 21.6242 70.5137C21.5519 70.2812 21.2135 70.2893 21.161 70.5272C21.0758 70.9118 21.0863 71.6132 21.4256 72.8918C21.4256 72.8918 20.4566 69.8522 19.8794 69.7946C19.3025 69.737 20.5838 73.5149 20.5838 73.5149C20.5838 73.5149 19.2911 70.745 18.8324 70.9031C18.5531 70.9991 19.4696 74.0972 19.4696 74.0972C19.4696 74.0972 18.0293 71.5964 17.9606 72.4268C17.9405 72.6686 20.0444 77.8799 18.95 80.6821C18.95 80.6821 20.7614 81.1894 21.6884 80.7406Z",
    fill: "#FFA681"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M52.9894 134.558L53.0404 134.784C48.0552 138.16 29.4077 135.855 29.4077 135.855C29.4398 135.464 29.4812 135.055 29.5358 134.632C29.594 134.16 29.6663 133.671 29.7491 133.166C29.9744 131.809 30.2765 130.341 30.6158 128.831C30.725 128.355 30.8339 127.873 30.9488 127.388C31.2854 125.947 31.6436 124.485 31.9826 123.061C32.0999 122.571 32.2151 122.089 32.3264 121.609C32.4818 120.942 32.6288 120.287 32.7698 119.651C32.9534 118.806 33.1172 117.994 33.2546 117.229C33.347 116.715 33.4277 116.222 33.4892 115.753C33.5603 115.258 33.6089 114.789 33.6386 114.356C33.3422 113.26 33.0659 112.187 32.8088 111.146C32.6807 110.617 32.555 110.099 32.4317 109.586C32.0486 107.947 31.712 106.386 31.418 104.925C31.3136 104.394 31.2104 103.877 31.1168 103.373C30.7907 101.649 30.5276 100.089 30.3155 98.728C30.2336 98.185 30.1565 97.6789 30.089 97.201C30.0143 96.6781 29.9504 96.1945 29.8946 95.7559C29.6444 93.8258 29.558 92.7317 29.558 92.7317C29.6018 92.6963 29.648 92.6642 29.6954 92.6297C30.2609 92.2277 31.1453 91.8497 32.1281 91.514C33.1655 91.1582 34.313 90.8489 35.3244 90.6047C35.4774 90.5681 35.628 90.5324 35.775 90.4979C37.104 90.1874 38.0976 90.0071 38.0976 90.0071C42.6192 90.9545 43.9092 90.3449 43.9092 90.3449L46.2081 91.0229L46.4784 91.1177L48.1536 91.7057L48.2211 91.7306L51.2254 92.7881L53.2288 93.491L52.4512 97.0771L52.1122 98.6431L51.088 103.364L50.7514 104.924L49.7316 109.628L49.3962 111.173L48.552 115.071L48.7203 115.816L49.05 117.261L49.5729 119.558L50.0485 121.636L50.3758 123.077L51.3598 127.41L51.6883 128.842L52.6639 133.126L52.9894 134.558Z",
    fill: "#9C78ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M46.4783 91.1177C45.9971 93.944 44.6266 96.7874 41.7778 97.0943C38.3362 97.4666 36.5518 93.1496 35.7754 90.4976C37.1044 90.1871 38.4817 89.8835 38.4817 89.8835C43.0033 90.8306 43.8757 90.2537 43.8757 90.2537L46.208 91.0229L46.4783 91.1177Z",
    fill: "#FFA681"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M41.428 94.7202C37.8211 94.7202 36.9586 90.2655 36.9502 90.2196C36.9325 90.123 36.9964 90.0303 37.0927 90.0126C37.1896 89.9952 37.282 90.0585 37.3 90.1551C37.333 90.3339 38.1511 94.5375 41.6377 94.3593C44.6891 94.2051 44.8685 90.8187 44.8748 90.6744C44.879 90.5763 44.9606 90.4995 45.0599 90.5043C45.158 90.5085 45.2342 90.5913 45.23 90.6891C45.2285 90.7275 45.0326 94.5435 41.6557 94.7142C41.5786 94.7184 41.5027 94.7202 41.428 94.7202Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M34.9573 93.4918C34.9573 93.9781 34.5631 94.3723 34.0768 94.3723C33.5905 94.3723 33.1963 93.9781 33.1963 93.4918C33.1963 93.0055 33.5905 92.6113 34.0768 92.6113C34.5631 92.6113 34.9573 93.0055 34.9573 93.4918Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M33.1941 97.7875C33.1941 98.2738 32.7999 98.668 32.3136 98.668C31.8273 98.668 31.4331 98.2738 31.4331 97.7875C31.4331 97.3012 31.8273 96.907 32.3136 96.907C32.7996 96.9073 33.1941 97.3015 33.1941 97.7875Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M38.8157 99.8185C38.8157 100.305 38.4215 100.699 37.9352 100.699C37.4489 100.699 37.0547 100.305 37.0547 99.8185C37.0547 99.3322 37.4489 98.938 37.9352 98.938C38.4218 98.938 38.8157 99.3325 38.8157 99.8185Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M34.8946 102.22C35.0749 102.672 34.8553 103.184 34.4035 103.365C33.952 103.545 33.4396 103.325 33.2593 102.873C33.079 102.422 33.2989 101.91 33.7504 101.729C34.2019 101.549 34.7143 101.769 34.8946 102.22Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M42.5266 103.846C42.5266 104.333 42.1324 104.727 41.6461 104.727C41.1598 104.727 40.7656 104.333 40.7656 103.846C40.7656 103.36 41.1598 102.966 41.6461 102.966C42.1324 102.966 42.5266 103.36 42.5266 103.846Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M48.1424 105.661C48.1424 106.147 47.7482 106.541 47.2619 106.541C46.7755 106.541 46.3813 106.147 46.3813 105.661C46.3813 105.174 46.7755 104.78 47.2619 104.78C47.7482 104.78 48.1424 105.174 48.1424 105.661Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M49.2718 94.3722C49.2718 94.8585 48.8776 95.2527 48.3913 95.2527C47.9049 95.2527 47.5107 94.8585 47.5107 94.3722C47.5107 93.8859 47.9049 93.4917 48.3913 93.4917C48.8776 93.492 49.2718 93.8859 49.2718 94.3722Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M42.8826 109.469C42.8826 109.955 42.4884 110.349 42.0021 110.349C41.5158 110.349 41.1216 109.955 41.1216 109.469C41.1216 108.982 41.5158 108.588 42.0021 108.588C42.4884 108.588 42.8826 108.983 42.8826 109.469Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M37.4588 112.199C37.4588 112.685 37.0646 113.079 36.5783 113.079C36.092 113.079 35.6978 112.685 35.6978 112.199C35.6978 111.713 36.092 111.318 36.5783 111.318C37.0646 111.319 37.4588 111.713 37.4588 112.199Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M36.8269 107.227C36.8269 107.713 36.4327 108.108 35.9464 108.108C35.4601 108.108 35.0659 107.713 35.0659 107.227C35.0659 106.741 35.4601 106.347 35.9464 106.347C36.4327 106.347 36.8269 106.741 36.8269 107.227Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M45.5008 100.049C45.5008 100.535 45.1066 100.929 44.6203 100.929C44.1339 100.929 43.7397 100.535 43.7397 100.049C43.7397 99.5627 44.1339 99.1685 44.6203 99.1685C45.1066 99.1685 45.5008 99.5627 45.5008 100.049Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M50.3689 98.9381C50.3689 99.4244 49.9747 99.8186 49.4884 99.8186C49.0021 99.8186 48.6079 99.4244 48.6079 98.9381C48.6079 98.4518 49.0021 98.0576 49.4884 98.0576C49.9747 98.0576 50.3689 98.4521 50.3689 98.9381Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M47.2615 110.926C47.2615 111.412 46.8673 111.806 46.381 111.806C45.8947 111.806 45.5005 111.412 45.5005 110.926C45.5005 110.439 45.8947 110.045 46.381 110.045C46.8673 110.045 47.2615 110.439 47.2615 110.926Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M47.4978 117.891C47.4978 118.378 47.1036 118.772 46.6173 118.772C46.131 118.772 45.7368 118.378 45.7368 117.891C45.7368 117.405 46.131 117.011 46.6173 117.011C47.1039 117.011 47.4978 117.405 47.4978 117.891Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M43.0162 114.985C43.1965 115.437 42.9769 115.949 42.5251 116.129C42.0736 116.31 41.5612 116.09 41.3809 115.638C41.2006 115.187 41.4205 114.674 41.872 114.494C42.3238 114.314 42.8359 114.534 43.0162 114.985Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M37.0225 117.565C37.2028 118.017 36.9829 118.529 36.5314 118.709C36.0799 118.89 35.5675 118.67 35.3872 118.218C35.2069 117.767 35.4268 117.254 35.8783 117.074C36.3298 116.894 36.8422 117.113 37.0225 117.565Z",
    fill: "#7846D1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M54.8552 145.661L54.6728 144.564L53.9623 140.309L53.7187 138.852L53.0404 134.784L51.8074 134.84L35.46 135.581L29.4084 135.855L29.0193 139.018L28.8372 140.491L28.2999 144.861L28.2012 145.661L54.8552 145.661Z",
    fill: "#9C78ED"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M54.854 145.661L54.6872 144.67L54.6734 144.566L54.5555 143.865L54.4376 143.172L53.9591 140.307L53.8205 139.461L53.7164 138.851L53.7026 138.761L53.0852 135.05L53.0435 134.786L52.988 134.558L52.9394 134.356L52.6619 133.129L52.1141 130.729L51.9545 130.042L51.6839 128.842L51.3578 127.406L51.1358 126.422L50.9762 125.735L50.3729 123.078L50.1509 122.107L50.0468 121.636L49.9982 121.421L49.5751 119.555C42.9307 121.518 35.8909 120.353 32.7696 119.652C32.631 120.283 32.4783 120.942 32.3256 121.608C32.2908 121.754 32.2563 121.899 32.2215 122.045C32.166 122.274 32.1105 122.503 32.055 122.732C32.0343 122.843 32.0064 122.947 31.9788 123.058C31.7223 124.147 31.4517 125.256 31.188 126.359C31.1325 126.588 31.0839 126.817 31.0284 127.039C31.0005 127.157 30.9729 127.268 30.9453 127.386C30.8343 127.871 30.7233 128.357 30.6123 128.828C30.4737 129.46 30.3417 130.077 30.2169 130.687C30.1683 130.916 30.1197 131.138 30.0783 131.36C29.9535 131.978 29.8425 132.581 29.7453 133.163C29.6619 133.67 29.5926 134.155 29.5371 134.634C29.5164 134.779 29.5023 134.925 29.4816 135.064C29.4609 135.299 29.433 135.528 29.4123 135.757C29.4123 135.792 29.4054 135.82 29.4054 135.854L29.0169 139.017L28.9545 139.509L28.8714 140.196L28.8366 140.487L28.4067 143.948L28.3233 144.642L28.2957 144.864L28.1997 145.661L54.854 145.661L54.854 145.661Z",
    fill: "#403657"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M46.8135 79.2891C46.8135 79.2891 47.8944 77.9199 48.6981 79.0521C49.5018 80.1843 48.3654 83.5287 46.3979 82.7124L46.8135 79.2891Z",
    fill: "#F97853"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M46.8271 81.679C46.8997 81.679 46.9666 81.6334 46.987 81.5635C47.2918 80.5312 48.4177 80.1124 48.4291 80.1085C48.5146 80.0773 48.5578 79.9861 48.5254 79.9048C48.493 79.8232 48.397 79.7821 48.3112 79.813C48.2587 79.8319 47.0179 80.2894 46.6669 81.4783C46.642 81.5623 46.6936 81.6493 46.7821 81.673C46.7971 81.6772 46.8124 81.679 46.8271 81.679Z",
    fill: "#EA5143"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M47.9635 81.1587C47.9944 81.1587 48.0256 81.1506 48.0535 81.1335C48.1306 81.0861 48.1528 80.9886 48.1033 80.9151C48.0952 80.9028 47.896 80.6142 47.4793 80.4369C47.3959 80.4012 47.2972 80.4369 47.2597 80.5167C47.2222 80.5962 47.2597 80.6898 47.3437 80.7255C47.6659 80.8626 47.8225 81.084 47.824 81.0861C47.8555 81.1332 47.9089 81.1587 47.9635 81.1587Z",
    fill: "#EA5143"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M46.3267 82.6908C46.1407 82.8978 46.0264 83.1705 46.0264 83.4696C46.0264 84.1155 46.552 84.6411 47.1979 84.6411C47.8438 84.6411 48.3694 84.1155 48.3694 83.4696C48.3694 83.0973 48.1951 82.7658 47.9236 82.5516C47.7874 82.4439 47.6272 82.3659 47.452 82.3269C47.4226 82.2477 47.437 82.1736 47.494 82.1052C47.7181 82.1541 47.9218 82.2564 48.0919 82.3986C48.3994 82.6542 48.595 83.04 48.595 83.4702C48.595 84.2409 47.9686 84.8673 47.1979 84.8673C46.4278 84.8673 45.8008 84.2409 45.8008 83.4702C45.8008 83.1381 45.9187 82.8345 46.1131 82.5951C46.1842 82.6266 46.2553 82.6587 46.3267 82.6908Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M38.4819 86.2847L38.4819 90.3871C38.4819 90.3871 40.3887 91.8583 41.8765 91.9861C43.3627 92.1157 43.8763 90.3619 43.8763 90.3619L43.8763 86.5439L38.4819 86.2847Z",
    fill: "#FFA681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M38.4819 86.6868L38.4819 88.3233C39.48 89.4309 41.2522 89.8235 43.8757 89.4363L43.8763 86.946L38.4819 86.6868Z",
    fill: "#F97853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M47.4631 80.8486C47.4157 81.2446 47.3596 81.6478 47.2885 82.0492C46.8172 84.7171 45.1297 87.5986 42.9988 88.0822C38.3976 89.1265 36.4869 85.5127 35.7513 82.8466C35.67 82.5505 35.8224 82.2112 35.7582 81.8605C35.6058 81.0298 35.2701 80.0861 35.1939 79.1552C35.1414 78.5102 35.1042 77.8739 35.0769 77.2991C35.0022 75.6779 35.9412 74.1878 37.4091 73.6061C39.5241 72.7649 42.736 72.0986 45.7783 73.883C46.9021 74.5421 47.6071 75.7619 47.6326 77.0975C47.6512 78.1178 47.6257 79.4516 47.4631 80.8486Z",
    fill: "#FFA681"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M41.6278 82.913C41.542 82.913 41.4664 82.8512 41.4517 82.7639C41.4355 82.6664 41.5009 82.5743 41.5984 82.5581L42.2122 82.4549L41.3665 80.2028C41.3317 80.1104 41.3785 80.0075 41.4709 79.9727C41.5633 79.9385 41.6665 79.9847 41.701 80.0771L42.6991 82.7354L41.6575 82.9103C41.6476 82.9121 41.6377 82.913 41.6278 82.913Z",
    fill: "#F97853"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M43.8296 79.933C43.8296 80.3266 44.0324 80.6458 44.2829 80.6458C44.5331 80.6458 44.7362 80.3266 44.7362 79.933C44.7362 79.5394 44.5334 79.2202 44.2829 79.2202C44.0324 79.2202 43.8296 79.5394 43.8296 79.933Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M38.8198 79.933C38.8198 80.3266 39.0226 80.6458 39.2731 80.6458C39.5236 80.6458 39.7264 80.3266 39.7264 79.933C39.7264 79.5394 39.5236 79.2202 39.2731 79.2202C39.0226 79.2202 38.8198 79.5394 38.8198 79.933Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M45.6151 78.0634C45.2506 77.9923 44.5138 77.875 43.729 77.9029C43.5226 77.9101 43.357 78.0658 43.3855 78.2302L43.3861 78.2344C43.4089 78.3655 43.5496 78.454 43.7146 78.4414C44.2495 78.4012 45.6487 78.4099 46.3 78.6037C46.318 78.5095 46.255 78.4093 46.1632 78.3217C46.0237 78.1885 45.8281 78.1048 45.6151 78.0634Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M38.3287 78.1493C38.692 78.0734 39.4273 77.9459 40.2124 77.9627C40.4191 77.9672 40.5865 78.1205 40.5604 78.2852L40.5598 78.2894C40.5388 78.4211 40.3996 78.5111 40.2343 78.5009C39.6988 78.4679 38.3002 78.4958 37.6516 78.6986C37.6321 78.6044 37.6939 78.5036 37.7848 78.4145C37.9216 78.2801 38.1163 78.1937 38.3287 78.1493Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M43.8297 83.9768C43.6974 84.6035 43.257 85.7561 41.7738 85.7561C40.287 85.7561 39.87 84.7028 39.7266 83.9768L43.8297 83.9768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M41.7945 86.8332C42.2226 86.8332 42.6003 86.6028 42.6165 86.5929C42.6987 86.5419 42.7242 86.4342 42.6735 86.3517C42.6228 86.2695 42.5151 86.244 42.4326 86.2944C42.4296 86.2962 42.1212 86.4828 41.7948 86.4828C41.4414 86.4828 41.1249 86.2956 41.1219 86.2938C41.0388 86.244 40.9314 86.2707 40.8816 86.3535C40.8318 86.4363 40.8582 86.5437 40.9407 86.5938C40.9566 86.6037 41.3409 86.8332 41.7945 86.8332Z",
    fill: "#F97853"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M47.6489 80.4299C47.606 80.4659 47.5646 80.4533 47.5259 80.3831C46.9181 79.3118 47.4893 77.1743 45.6908 76.3547C44.321 75.7298 43.8293 74.4479 43.8293 74.4479C43.5161 74.984 42.7001 75.4757 42.7001 75.4757C42.7001 75.4757 40.6313 76.7015 38.4815 77.5298C37.8425 77.7761 37.3874 78.026 37.0688 78.2405C37.0937 78.2474 37.1069 78.2513 37.1069 78.2513C37.1069 78.2513 36.5117 79.2182 36.947 80.7215C37.3826 82.2239 36.8222 84.7031 35.8553 85.2752C35.8724 85.2332 36.5978 83.5187 36.188 82.1201C35.9519 81.3182 35.954 80.0426 35.7302 79.2779C35.4824 79.1072 34.9094 78.8195 34.7153 78.704C34.6601 78.0464 34.6202 77.3981 34.5923 76.8122C34.5137 75.1595 35.5031 73.6409 37.0508 73.0472C39.2801 72.1901 42.6659 71.5115 45.8729 73.3301C47.0573 74.0018 47.8007 75.2453 47.828 76.6067C47.8478 77.6459 47.8205 79.0055 47.6489 80.4299Z",
    fill: "#403657"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M35.7301 79.2779C35.7301 79.2779 34.4734 77.753 33.7318 78.8525C32.9902 79.952 34.0852 83.3228 35.9008 82.5302L35.7301 79.2779Z",
    fill: "#FFA681"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M35.7811 82.5845C35.911 82.8305 35.956 83.1227 35.8834 83.4128C35.7268 84.0395 35.0893 84.4217 34.4626 84.2651C33.8358 84.1082 33.4536 83.471 33.6102 82.8443C33.7005 82.4831 33.9501 82.2038 34.2658 82.0619C34.4239 81.9905 34.5982 81.9536 34.7776 81.9581C34.8088 81.8912 34.8247 81.8186 34.7905 81.7328C34.5613 81.7259 34.3387 81.7757 34.1395 81.8723C33.7791 82.0457 33.4956 82.3724 33.3915 82.7897C33.2046 83.5373 33.66 84.2972 34.408 84.4841C35.155 84.671 35.9155 84.2156 36.1024 83.4677C36.1831 83.1455 36.1423 82.8224 36.0118 82.5428C35.9347 82.5569 35.8579 82.571 35.7811 82.5845Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M35.4578 81.4031C35.3906 81.4031 35.3291 81.3587 35.3102 81.2909C35.0288 80.2883 33.9901 79.8818 33.9796 79.8779C33.9007 79.8476 33.8608 79.7591 33.8908 79.6799C33.9208 79.6007 34.0093 79.5608 34.0885 79.5908C34.1371 79.6091 35.282 80.0534 35.606 81.2081C35.6288 81.2897 35.5814 81.3743 35.4998 81.3974C35.4857 81.4013 35.4716 81.4031 35.4578 81.4031Z",
    fill: "#F97853"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M34.4096 80.8983C34.3811 80.8983 34.3523 80.8905 34.3268 80.874C34.2554 80.8281 34.235 80.7333 34.2809 80.6619C34.2887 80.6502 34.4723 80.3697 34.8569 80.1978C34.9337 80.163 35.0249 80.1978 35.0597 80.2752C35.0942 80.3526 35.0597 80.4432 34.9823 80.478C34.685 80.6109 34.5404 80.8263 34.5392 80.8281C34.5095 80.8734 34.46 80.8983 34.4096 80.8983Z",
    fill: "#F97853"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M102.295 112.388C99.3705 114.488 94.7951 115.928 94.7951 115.928L93.8582 112.558L93.1274 109.929L92.6117 108.076L87.3677 108.073C87.6518 109.056 87.9452 110.059 88.2401 111.048C88.6184 112.323 88.9958 113.572 89.3546 114.724C89.8607 116.344 90.3275 117.769 90.7037 118.787C90.7916 119.025 90.8939 119.283 91.0082 119.559C91.709 121.453 92.2751 123.506 94.9502 122.218C97.3052 121.084 100.499 119.511 102.095 118.467L102.295 112.388Z",
    fill: "#FFA681"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M88.2397 111.048C88.618 112.323 88.9952 113.572 89.3543 114.723C91.4948 114.497 92.9768 113.436 93.8585 112.558L93.1277 109.929L88.2397 111.048Z",
    fill: "#F97853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M87.1264 92.6572C87.1264 92.6572 92.597 105.704 94.9499 109.931C94.9499 109.931 91.6526 112.734 88.4408 112.811C88.4408 112.811 86.5897 98.4868 87.1264 92.6572Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M74.3181 145.671C74.373 144.758 74.4249 143.889 74.4723 143.083C74.6658 139.79 74.7906 137.542 74.7906 137.542L73.5009 137.484L72.7737 137.451L64.005 137.062C64.005 137.062 63.8454 139.576 63.6573 143.268C63.6189 144.023 63.579 144.828 63.5391 145.671L74.3181 145.671L74.3181 145.671Z",
    fill: "#9C78ED"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M73.5004 137.484L74.7901 137.542C74.7901 137.542 74.6656 139.79 74.4718 143.084C71.1028 143.364 67.4245 143.479 63.6567 143.268C63.8448 139.576 64.0044 137.062 64.0044 137.062L72.7732 137.452L73.5004 137.484Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M73.0402 145.671C73.2436 142.153 73.4107 139.139 73.5013 137.484L72.7741 137.452C72.6832 139.114 72.5155 142.141 72.3115 145.671L73.0402 145.671Z",
    fill: "#7846D1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M77.1441 145.671L87.9231 145.671C87.8832 144.828 87.8437 144.023 87.805 143.268C87.6169 139.576 87.4572 137.062 87.4572 137.062L78.6885 137.451L77.9616 137.484L76.6719 137.542C76.6719 137.542 76.7964 139.79 76.9899 143.083C77.0373 143.889 77.0892 144.758 77.1441 145.671Z",
    fill: "#9C78ED"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M77.9614 137.484L76.6714 137.542C76.6714 137.542 76.7959 139.79 76.9897 143.083C80.3587 143.364 84.037 143.478 87.8048 143.268C87.6167 139.576 87.4571 137.062 87.4571 137.062L78.6883 137.451L77.9614 137.484Z",
    fill: "#7846D1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M79.1503 145.671C78.9463 142.141 78.7789 139.114 78.6877 137.452L77.9604 137.484C78.051 139.139 78.2179 142.153 78.4216 145.671L79.1503 145.671Z",
    fill: "#7846D1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M62.1017 130.81C62.1005 130.99 62.1017 131.168 62.1017 131.344C62.1056 134.551 62.1215 137.036 62.1374 138.256C65.2349 139.095 68.3322 139.637 71.4309 139.888C71.5722 139.898 71.7105 139.909 71.8518 139.919C71.9271 139.925 72.0021 139.93 72.0774 139.934C72.2436 139.946 72.411 139.956 72.576 139.964C72.7608 139.976 72.9441 139.985 73.1301 139.994C75.2382 140.092 77.346 140.054 79.4556 139.881C79.8816 139.845 80.3052 139.804 80.7313 139.758C80.7589 139.756 80.7853 139.753 80.8132 139.75C80.9215 139.738 81.0295 139.725 81.139 139.712C81.205 139.704 81.271 139.696 81.3355 139.688C83.7877 139.396 86.2402 138.917 88.6939 138.256C88.7005 137.702 88.7032 136.88 88.7032 135.844C88.7032 135.652 88.7032 135.454 88.702 135.247L88.702 135.246C88.7008 133.764 88.6915 131.92 88.6756 129.836C88.6744 129.658 88.6729 129.478 88.6717 129.296C88.6597 127.908 88.6453 126.422 88.6267 124.872C88.624 124.692 88.6228 124.513 88.6201 124.332C88.6003 122.743 88.5766 121.091 88.549 119.414C88.5319 118.391 88.5133 117.358 88.4923 116.324C88.4713 115.276 88.4488 114.227 88.4236 113.185C88.4182 112.958 88.4131 112.731 88.4065 112.505C88.1665 102.649 87.751 93.5906 87.0637 92.5802C86.5876 91.8809 85.4965 91.0592 84.2116 90.2309C84.0547 90.1307 83.8951 90.029 83.7328 89.9276C83.1853 89.5859 78.72 88.0688 78.1527 87.7352L73.4328 87.4055C73.4037 87.4226 68.8908 88.9451 68.862 88.9607C68.6682 89.0714 68.4714 89.1836 68.2776 89.2958C66.6063 90.26 64.9571 91.2758 64.0073 92.1506C63.8687 92.2772 63.7448 92.4011 63.6392 92.5226C63.5549 92.6189 63.4796 92.7125 63.419 92.8049C63.3623 92.888 63.3068 93.0278 63.254 93.2192C62.6828 95.2943 62.3834 103.449 62.2343 112.322C62.2238 112.958 62.2145 113.597 62.2052 114.239C62.2013 114.52 62.1974 114.802 62.1932 115.084C62.1893 115.278 62.1866 115.473 62.1854 115.667C62.1842 115.765 62.1827 115.861 62.1815 115.959C62.1749 116.442 62.1695 116.923 62.1656 117.402C62.1617 117.757 62.1578 118.111 62.1536 118.464C62.111 122.933 62.0978 127.273 62.1017 130.81Z",
    fill: "#7846D1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M53.6613 143.482C53.5452 144.742 55.0794 144.058 54.6453 141.506C54.2127 138.953 55.4421 136.642 55.9726 136.716C56.5042 136.791 55.5333 139.503 56.0056 140.481C56.4766 141.458 57.0859 139.559 57.6928 138.407C58.3222 137.211 58.285 134.6 57.9988 132.737C57.7126 130.873 61.0897 119.556 61.1068 116.277L61.5184 114.887L63.025 109.796L65.3836 101.825C65.3836 101.825 63.9706 95.7908 61.5883 96.3092C61.5883 96.3092 60.3271 100.512 58.9792 105.252C58.7509 106.056 58.5202 106.877 58.2919 107.695C57.3316 111.131 56.4292 114.524 56.0097 116.537C54.9015 121.852 54.816 132.9 54.816 132.9C54.816 132.9 52.8609 136.959 52.8147 138.765C52.7655 140.691 53.7759 142.222 53.6613 143.482Z",
    fill: "#FFA681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M58.2915 107.694L61.5183 114.887L63.0249 109.796L58.9791 105.251C58.7505 106.056 58.5198 106.877 58.2915 107.694Z",
    fill: "#F97853"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M58.1318 105.552C59.5472 107.979 60.9867 110.394 62.4204 112.812C62.8926 111.23 63.3822 109.712 63.8412 108.316C63.8424 108.312 63.8439 108.309 63.8451 108.305C64.0284 107.747 64.2078 107.209 64.3794 106.695C64.3821 106.685 64.3848 106.676 64.3887 106.668C64.4481 106.488 64.506 106.309 64.5654 106.135L64.5654 106.134C65.25 104.064 65.7804 102.419 65.9319 101.461C66.3408 98.879 65.2263 93.8214 63.6564 92.8239C63.6156 92.9148 63.4917 92.634 63.4179 92.8056C63.1422 93.4428 61.9179 95.0165 61.3122 96.5492C61.2345 96.7445 61.1553 96.9476 61.0734 97.1546C60.1962 99.4088 59.1236 102.341 58.1318 105.552Z",
    fill: "#7846D1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M75.5832 92.1249C77.6271 92.1249 79.068 90.2602 79.1283 90.1807C79.2144 90.0676 79.1982 89.9014 79.0926 89.8096C78.987 89.7178 78.8316 89.7349 78.7455 89.8477C78.7269 89.872 77.3853 91.5972 75.5832 91.5972C73.8024 91.5972 72.7161 89.6449 72.7056 89.6251C72.6369 89.4994 72.4857 89.4568 72.3684 89.53C72.2508 89.6032 72.2106 89.7643 72.279 89.8903C72.3285 89.9815 73.515 92.1249 75.5832 92.1249Z",
    fill: "#6020BD"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M84.2247 109.993C84.2625 109.993 84.3006 109.984 84.3369 109.964C84.4593 109.898 84.5085 109.738 84.4464 109.606L83.5551 107.723C83.4933 107.592 83.3436 107.539 83.2209 107.606C83.0982 107.672 83.0493 107.832 83.1114 107.963L84.0027 109.847C84.0462 109.94 84.1338 109.993 84.2247 109.993Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M86.0823 108.45C86.1144 108.471 86.1513 108.485 86.1918 108.489C86.3286 108.502 86.4495 108.394 86.4615 108.248L86.6361 106.145C86.6484 105.999 86.5473 105.869 86.4102 105.856C86.2734 105.843 86.1525 105.951 86.1405 106.098L85.9659 108.201C85.9572 108.304 86.0052 108.399 86.0823 108.45Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M81.2935 105.189C81.4132 105.189 81.5185 105.097 81.5386 104.967L81.8605 102.884C81.8827 102.739 81.7912 102.602 81.6556 102.578C81.5197 102.554 81.3919 102.652 81.3697 102.797L81.0478 104.88C81.0256 105.025 81.117 105.162 81.2526 105.186C81.2664 105.188 81.2803 105.189 81.2935 105.189Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M73.2859 105.965C73.3291 105.965 73.3726 105.953 73.4125 105.927C73.5307 105.853 73.57 105.69 73.4998 105.563L72.4942 103.746C72.4243 103.62 72.2716 103.578 72.1534 103.653C72.0352 103.728 71.9959 103.891 72.0661 104.018L73.0717 105.834C73.1179 105.918 73.201 105.965 73.2859 105.965Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M83.1234 97.8224C83.1696 97.8224 83.2164 97.8086 83.2581 97.7798L84.9156 96.6332C85.0311 96.5534 85.0641 96.3887 84.9894 96.2654C84.9147 96.1421 84.7608 96.1067 84.6453 96.1865L82.9878 97.3331C82.8723 97.4129 82.8393 97.5776 82.914 97.7009C82.962 97.7795 83.0418 97.8224 83.1234 97.8224Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M75.7398 114.747C75.7776 114.747 75.8157 114.738 75.852 114.718C75.9744 114.652 76.0236 114.492 75.9615 114.36L75.0702 112.477C75.0081 112.346 74.8587 112.293 74.736 112.36C74.6136 112.426 74.5644 112.586 74.6265 112.717L75.5178 114.601C75.5613 114.693 75.6489 114.747 75.7398 114.747Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M79.656 99.2395C79.7388 99.2395 79.8198 99.1954 79.8672 99.1147C79.9401 98.9902 79.9047 98.8258 79.7883 98.7481L78.1152 97.6279C77.9988 97.5502 77.8452 97.5874 77.7723 97.7122C77.6994 97.8367 77.7348 98.0011 77.8512 98.0788L79.5243 99.199C79.5654 99.2263 79.611 99.2395 79.656 99.2395Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M83.6355 91.4067C83.6319 91.458 83.6418 91.5084 83.664 91.5504C83.7021 91.6284 83.7774 91.6836 83.8662 91.6902C84.003 91.7007 84.1215 91.59 84.1314 91.4436L84.2103 90.2313C84.0537 90.1311 83.8944 90.0294 83.7318 89.928L83.6355 91.4067Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M85.866 102.965C85.9488 102.965 86.0298 102.921 86.0772 102.84C86.1501 102.715 86.1147 102.551 85.9983 102.473L84.3252 101.353C84.2088 101.275 84.0552 101.313 83.9823 101.437C83.9094 101.562 83.9448 101.726 84.0612 101.804L85.7343 102.924C85.7751 102.951 85.8207 102.965 85.866 102.965Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M72.5228 93.7725C72.5696 93.7725 72.6173 93.7584 72.6593 93.7287C72.7739 93.6477 72.8057 93.483 72.7301 93.3603L71.7761 91.8117C71.7008 91.689 71.5463 91.6548 71.4317 91.7358C71.3171 91.8168 71.2853 91.9815 71.3609 92.1045L72.3149 93.6531C72.3626 93.7302 72.4418 93.7725 72.5228 93.7725Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M71.6677 120.523C71.7331 120.523 71.7982 120.495 71.8471 120.441L73.2142 118.918C73.3093 118.812 73.306 118.643 73.207 118.542C73.108 118.44 72.9505 118.443 72.8554 118.55L71.4883 120.072C71.3929 120.178 71.3965 120.347 71.4955 120.449C71.5438 120.498 71.6059 120.523 71.6677 120.523Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M76.691 120.206C76.7564 120.206 76.8215 120.178 76.8704 120.124L78.2375 118.601C78.3329 118.495 78.3293 118.327 78.2303 118.225C78.131 118.123 77.9738 118.127 77.8787 118.232L76.5116 119.755C76.4165 119.861 76.4198 120.03 76.5188 120.132C76.5671 120.181 76.6292 120.206 76.691 120.206Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M80.3025 130.5C80.3253 130.435 80.3244 130.36 80.2938 130.292L79.4403 128.388C79.3809 128.256 79.2324 128.2 79.1085 128.263C78.9846 128.327 78.9324 128.486 78.9918 128.618L79.8453 130.522C79.9047 130.655 80.0532 130.71 80.1771 130.647C80.2377 130.616 80.2809 130.562 80.3025 130.5Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M65.8865 136.782C65.9096 136.716 65.9084 136.641 65.8778 136.573L65.0243 134.669C64.9649 134.537 64.8164 134.481 64.6925 134.545C64.5686 134.608 64.5164 134.767 64.5758 134.899L65.4293 136.803C65.4887 136.936 65.6372 136.992 65.7611 136.928C65.8217 136.897 65.8649 136.844 65.8865 136.782Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M72.0771 139.935C72.2436 139.946 72.4102 139.957 72.5755 139.965L72.7495 138.779C72.7705 138.634 72.6778 138.498 72.5422 138.476C72.4066 138.453 72.2794 138.552 72.2584 138.698L72.0771 139.935Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M70.0914 136.351C70.1451 136.311 70.1838 136.248 70.1946 136.174L70.5 134.088C70.5213 133.942 70.4286 133.807 70.2927 133.784C70.1568 133.761 70.0299 133.86 70.0086 134.005L69.7032 136.091C69.6819 136.237 69.7746 136.372 69.9105 136.395C69.9765 136.407 70.0407 136.389 70.0914 136.351Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M82.0942 118.911C82.1365 118.911 82.1794 118.899 82.2187 118.875C82.3375 118.802 82.378 118.639 82.3093 118.511L81.3205 116.684C81.2518 116.557 81.0997 116.514 80.9806 116.588C80.8618 116.661 80.821 116.824 80.89 116.951L81.8788 118.778C81.9247 118.863 82.0081 118.911 82.0942 118.911Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M79.1907 114.344C79.2807 114.344 79.3677 114.291 79.4121 114.2L80.3169 112.324C80.3799 112.193 80.3319 112.033 80.2098 111.965C80.088 111.897 79.938 111.949 79.8747 112.08L78.9696 113.956C78.9066 114.086 78.9546 114.247 79.0767 114.314C79.1133 114.334 79.1523 114.344 79.1907 114.344Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M87.0542 114.069C87.08 114.102 87.1133 114.127 87.1478 114.142C87.2318 114.179 87.3302 114.166 87.4043 114.1L88.4219 113.186C88.4168 112.959 88.412 112.732 88.406 112.505L87.0839 113.692C86.9792 113.788 86.9654 113.955 87.0542 114.069Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M79.2033 94.4385C79.2936 94.4385 79.3803 94.386 79.4247 94.2945L80.3298 92.4183C80.3928 92.2878 80.3448 92.1273 80.2227 92.0598C80.1009 91.9923 79.9509 92.0436 79.8876 92.1744L78.9828 94.0506C78.9198 94.1811 78.9678 94.3416 79.0899 94.4091C79.1259 94.4292 79.1649 94.4385 79.2033 94.4385Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M73.4032 101.312C73.4188 101.312 73.4347 101.311 73.4506 101.307C73.5856 101.279 73.6738 101.14 73.6477 100.996L73.2732 98.923C73.2471 98.7784 73.1167 98.6845 72.9819 98.7121C72.8469 98.74 72.7587 98.8795 72.7848 99.0238L73.1593 101.096C73.1821 101.224 73.2861 101.312 73.4032 101.312Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M76.6326 103.132C76.6482 103.132 76.6641 103.131 76.68 103.127C76.815 103.099 76.9032 102.96 76.8771 102.816L76.5027 100.743C76.4766 100.598 76.3461 100.505 76.2114 100.532C76.0764 100.56 75.9882 100.699 76.0143 100.844L76.3887 102.917C76.4115 103.044 76.5156 103.132 76.6326 103.132Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M74.319 96.2931C74.4015 96.2931 74.4819 96.2496 74.5293 96.1698L75.5871 94.3875C75.6606 94.2636 75.6264 94.0989 75.5103 94.0203C75.3939 93.9417 75.2406 93.9786 75.1668 94.1022L74.109 95.8845C74.0355 96.0084 74.0697 96.1731 74.1858 96.2517C74.2272 96.2799 74.2734 96.2931 74.319 96.2931Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M84.0228 114.673C84.0909 114.596 84.1113 114.479 84.0657 114.377L83.2155 112.471C83.1564 112.339 83.0079 112.283 82.884 112.346C82.7595 112.409 82.7073 112.568 82.7667 112.7L83.6169 114.606C83.676 114.738 83.8245 114.794 83.9484 114.731C83.9775 114.717 84.0024 114.697 84.0228 114.673Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M77.6233 109.145C77.7226 109.145 77.8165 109.081 77.8549 108.976L78.5743 107.01C78.6244 106.874 78.5614 106.719 78.4333 106.666C78.3052 106.612 78.1609 106.679 78.1111 106.817L77.3917 108.782C77.3416 108.919 77.4046 109.073 77.5327 109.127C77.5624 109.139 77.593 109.145 77.6233 109.145Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M69.7198 121.288C69.7576 121.288 69.7957 121.279 69.832 121.259C69.9544 121.193 70.0036 121.033 69.9415 120.902L69.0502 119.018C68.9884 118.887 68.8387 118.834 68.716 118.901C68.5936 118.967 68.5444 119.127 68.6065 119.258L69.4978 121.142C69.5413 121.235 69.6289 121.288 69.7198 121.288Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M82.8193 134.827C82.8196 134.867 82.8286 134.908 82.8472 134.946C82.9102 135.077 83.0605 135.128 83.1827 135.06L84.9353 134.089C85.0571 134.022 85.1051 133.861 85.0418 133.73C84.9788 133.6 84.8285 133.549 84.7064 133.617L82.9537 134.588C82.8673 134.635 82.8184 134.729 82.8193 134.827Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M87.5772 136.034C87.5772 136.075 87.5859 136.116 87.6045 136.154C87.6675 136.285 87.8178 136.335 87.9399 136.268L88.7022 135.845C88.7022 135.653 88.7022 135.455 88.701 135.248L87.7119 135.795C87.6255 135.843 87.576 135.937 87.5772 136.034Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M80.2129 138.382L80.8123 139.751C80.9209 139.74 81.0295 139.726 81.139 139.713C81.2044 139.705 81.2698 139.697 81.3352 139.689L80.6629 138.156C80.605 138.023 80.4571 137.965 80.3323 138.028C80.2081 138.091 80.1538 138.249 80.2129 138.382Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M66.4849 116.484C66.6046 116.484 66.7099 116.392 66.73 116.262L67.0519 114.179C67.0744 114.034 66.9826 113.897 66.847 113.873C66.7111 113.849 66.5836 113.947 66.5611 114.092L66.2392 116.175C66.217 116.32 66.3085 116.457 66.4441 116.481C66.4576 116.483 66.4714 116.484 66.4849 116.484Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M66.2795 101.115C66.3227 101.115 66.3662 101.103 66.4058 101.078C66.524 101.003 66.5633 100.84 66.4931 100.714L65.4875 98.8971C65.4176 98.7708 65.2649 98.7288 65.147 98.8038C65.0288 98.8788 64.9895 99.0417 65.0597 99.1683L66.0653 100.985C66.1118 101.069 66.1946 101.115 66.2795 101.115Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M69.5128 108.499C69.559 108.499 69.6058 108.486 69.6475 108.457L71.305 107.31C71.4205 107.23 71.4535 107.066 71.3788 106.942C71.3041 106.819 71.1502 106.784 71.035 106.863L69.3775 108.01C69.262 108.09 69.229 108.255 69.3037 108.378C69.3514 108.456 69.4312 108.499 69.5128 108.499Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M87.0621 120.883C87.0999 120.883 87.138 120.874 87.1743 120.854C87.2967 120.788 87.3459 120.628 87.2838 120.497L86.3925 118.613C86.3304 118.482 86.181 118.43 86.0583 118.496C85.9356 118.562 85.8867 118.723 85.9488 118.853L86.8401 120.737C86.8839 120.83 86.9712 120.883 87.0621 120.883Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M66.6887 111.361C66.7715 111.361 66.8525 111.317 66.8999 111.236C66.9728 111.111 66.9374 110.947 66.821 110.869L65.1479 109.749C65.0315 109.671 64.8779 109.709 64.805 109.833C64.7321 109.958 64.7675 110.122 64.8839 110.2L66.557 111.32C66.5978 111.347 66.6437 111.361 66.6887 111.361Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M70.6995 114.025C70.7604 114.085 70.848 114.112 70.9338 114.087C71.0664 114.048 71.1447 113.902 71.1087 113.76L70.5906 111.723C70.5543 111.582 70.4181 111.498 70.2852 111.536C70.1526 111.575 70.0743 111.721 70.1103 111.863L70.6284 113.9C70.6413 113.95 70.6665 113.993 70.6995 114.025Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M63.6382 92.5229L64.0711 93.2246C64.1191 93.3011 64.198 93.3434 64.2796 93.3434C64.3264 93.3434 64.3732 93.3302 64.4152 93.2999C64.5298 93.2195 64.5619 93.0545 64.4866 92.9318L64.0057 92.1509C63.8677 92.2775 63.7441 92.4014 63.6382 92.5229Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M61.7461 97.1545L62.2063 97.9012C62.2543 97.9789 62.3332 98.0212 62.4148 98.0212C62.4616 98.0212 62.5087 98.0068 62.5516 97.9777C62.6662 97.8958 62.6971 97.7311 62.6218 97.6084L61.9693 96.5491C61.8967 96.7441 61.8226 96.9472 61.7461 97.1545Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M83.2608 127.46C83.3262 127.46 83.3914 127.433 83.4403 127.378L84.8074 125.856C84.9025 125.75 84.8992 125.582 84.8002 125.48C84.7012 125.378 84.5437 125.381 84.4486 125.487L83.0814 127.01C82.9863 127.116 82.9897 127.284 83.0887 127.386C83.1367 127.436 83.1987 127.46 83.2608 127.46Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M74.1642 132.785C74.2296 132.785 74.2947 132.757 74.3436 132.703L75.7107 131.18C75.8058 131.074 75.8025 130.905 75.7035 130.803C75.6045 130.701 75.447 130.705 75.3519 130.811L73.9848 132.334C73.8897 132.44 73.893 132.608 73.992 132.71C74.0403 132.76 74.1024 132.785 74.1642 132.785Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M71.6365 130.67C71.6776 130.616 71.6989 130.544 71.6899 130.469L71.4433 128.375C71.4262 128.229 71.3017 128.126 71.1655 128.144C71.029 128.162 70.9324 128.295 70.9498 128.441L71.1964 130.536C71.2135 130.682 71.338 130.785 71.4742 130.767C71.5408 130.758 71.5975 130.721 71.6365 130.67Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M76.8171 136.574C76.8825 136.574 76.9476 136.546 76.9965 136.492L78.3636 134.969C78.4587 134.863 78.4554 134.695 78.3564 134.593C78.2574 134.491 78.0999 134.495 78.0048 134.601L76.6377 136.124C76.5423 136.23 76.5459 136.398 76.6449 136.5C76.6932 136.549 76.7553 136.574 76.8171 136.574Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M62.1016 130.81C62.1004 130.991 62.1016 131.169 62.1016 131.345L63.6445 131.483C63.7813 131.496 63.9022 131.387 63.9133 131.24C63.9256 131.094 63.8233 130.966 63.6862 130.953L62.1016 130.81Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M80.173 124.258C80.2384 124.258 80.3035 124.23 80.3524 124.176L81.7195 122.653C81.8146 122.547 81.8113 122.379 81.7123 122.277C81.613 122.175 81.4558 122.178 81.3607 122.285L79.9936 123.807C79.8985 123.913 79.9018 124.082 80.0008 124.184C80.0491 124.233 80.1109 124.258 80.173 124.258Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M73.5958 123.596C73.6 123.666 73.63 123.734 73.684 123.782L75.1948 125.141C75.2998 125.235 75.4567 125.221 75.5452 125.109C75.6337 124.996 75.6202 124.828 75.5149 124.734L74.0041 123.375C73.8991 123.281 73.7422 123.295 73.6537 123.408C73.6105 123.462 73.5916 123.53 73.5958 123.596Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M66.3973 131.07C66.4396 131.07 66.4825 131.058 66.5215 131.034C66.6403 130.961 66.6811 130.798 66.6121 130.67L65.6233 128.843C65.5546 128.716 65.4025 128.673 65.2834 128.746C65.1646 128.82 65.1238 128.983 65.1928 129.11L66.1816 130.937C66.2278 131.022 66.3115 131.07 66.3973 131.07Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M64.6855 125.639C64.7758 125.639 64.8625 125.586 64.9069 125.495L65.8121 123.619C65.8751 123.488 65.827 123.328 65.7049 123.261C65.5831 123.193 65.4331 123.244 65.3698 123.375L64.4647 125.251C64.4017 125.382 64.4497 125.542 64.5718 125.61C64.6081 125.629 64.6471 125.639 64.6855 125.639Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M67.3848 104.336C67.4748 104.336 67.5618 104.284 67.6062 104.192L68.511 102.316C68.574 102.186 68.526 102.025 68.4039 101.958C68.2821 101.89 68.1321 101.942 68.0688 102.072L67.164 103.948C67.101 104.079 67.149 104.24 67.2711 104.307C67.3074 104.327 67.3464 104.336 67.3848 104.336Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M66.3963 96.463C66.4119 96.463 66.4278 96.4615 66.4437 96.4582C66.5787 96.4303 66.6669 96.2908 66.6408 96.1465L66.2664 94.0739C66.2403 93.9296 66.1098 93.8354 65.9751 93.863C65.8401 93.8909 65.7519 94.0304 65.778 94.1747L66.1524 96.2473C66.1755 96.3748 66.2796 96.463 66.3963 96.463Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M61.8509 103.616C61.8665 103.616 61.8824 103.614 61.8983 103.611C62.0333 103.583 62.1215 103.444 62.0954 103.299L61.721 101.227C61.6949 101.082 61.5644 100.988 61.4297 101.016C61.2947 101.044 61.2065 101.183 61.2326 101.327L61.607 103.4C61.6301 103.528 61.7342 103.616 61.8509 103.616Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M69.6263 98.283C69.6419 98.283 69.6578 98.2815 69.6737 98.2782C69.8087 98.2503 69.8969 98.1108 69.8708 97.9665L69.4964 95.8938C69.4703 95.7492 69.3398 95.6557 69.2051 95.683C69.0701 95.7109 68.9819 95.8503 69.008 95.9946L69.3824 98.0673C69.4052 98.1945 69.5096 98.283 69.6263 98.283Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M68.1442 91.0624C68.1922 91.0741 68.2393 91.0702 68.2822 91.0546C68.3599 91.0255 68.4229 90.9556 68.4427 90.8647L68.8609 88.9612C68.6674 89.0719 68.4712 89.1841 68.2762 89.2963L67.9591 90.742C67.927 90.8857 68.0095 91.0282 68.1442 91.0624Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M62.4535 106.821C62.5357 106.821 62.6164 106.777 62.6638 106.697L63.7216 104.915C63.7951 104.791 63.7609 104.627 63.6451 104.548C63.5287 104.469 63.3754 104.506 63.3016 104.63L62.2438 106.412C62.1703 106.536 62.2045 106.701 62.3203 106.779C62.3617 106.807 62.4079 106.821 62.4535 106.821Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M69.5176 125.969C69.5857 125.891 69.6058 125.774 69.5605 125.672L68.7106 123.767C68.6515 123.634 68.503 123.578 68.3791 123.641C68.2546 123.705 68.2024 123.864 68.2618 123.996L69.1117 125.901C69.1708 126.034 69.3193 126.09 69.4432 126.027C69.472 126.012 69.4969 125.992 69.5176 125.969Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M87.0139 129.549L88.6753 129.837C88.6741 129.659 88.6729 129.479 88.6702 129.297L87.094 129.023C86.9584 129 86.83 129.098 86.809 129.243C86.7868 129.388 86.878 129.525 87.0139 129.549Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M87.5192 124.681L88.6256 124.873C88.6232 124.693 88.622 124.514 88.6193 124.333L87.5993 124.157C87.4637 124.133 87.3365 124.232 87.3143 124.377C87.2924 124.522 87.3836 124.658 87.5192 124.681Z",
    fill: "#6020BD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M63.1179 120.44C63.2175 120.44 63.3114 120.376 63.3495 120.271L64.0689 118.305C64.119 118.168 64.056 118.014 63.9279 117.961C63.7998 117.907 63.6555 117.974 63.6057 118.111L62.8863 120.077C62.8362 120.214 62.8995 120.368 63.0273 120.422C63.0573 120.434 63.0879 120.44 63.1179 120.44Z",
    fill: "#6020BD"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M62.2046 114.238C62.6717 112.308 63.2585 110.163 63.8402 108.315C63.8414 108.312 63.8429 108.309 63.8441 108.305C64.0235 107.734 64.2029 107.192 64.3784 106.694C64.3811 106.685 64.3838 106.676 64.3877 106.668C64.4417 106.511 64.4972 106.359 64.5512 106.212C64.559 106.185 64.5644 106.16 64.5644 106.135L64.5644 106.134C64.5644 106.045 64.5089 105.962 64.4207 105.929C64.3058 105.889 64.1792 105.946 64.1384 106.061C63.542 107.686 62.8376 110.027 62.2334 112.322C62.2232 112.957 62.2139 113.597 62.2046 114.238Z",
    fill: "#6020BD"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M69.3363 76.978C69.3363 76.978 67.6041 75.0691 68.2578 72.8482C68.9115 70.6276 70.6998 70.6519 70.6998 70.6519C70.6998 70.6519 71.7432 68.29 73.5201 68.212C75.297 68.134 76.9722 64.9784 78.5889 65.8354C80.2059 66.6925 78.4137 68.5627 78.4137 68.5627C78.4137 68.5627 81.184 65.6407 82.0975 66.4978C83.011 67.3549 80.8291 69.6535 80.8291 69.6535C80.8291 69.6535 83.1568 68.0173 83.9215 68.6404C84.6862 69.2638 82.0975 71.9521 82.0975 71.9521C82.0975 71.9521 83.7724 74.9716 82.0867 76.3255L69.3363 76.978Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M81.4382 77.6172C81.4382 77.6172 82.5458 76.1403 83.3693 77.3616C84.1928 78.5825 83.0285 82.1894 81.0122 81.3089L81.4382 77.6172Z",
    fill: "#F97853"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M81.4524 80.1944C81.5268 80.1944 81.5952 80.1452 81.6165 80.0699C81.9291 78.9563 83.0826 78.5048 83.0943 78.5006C83.1822 78.467 83.2263 78.3686 83.193 78.281C83.1597 78.1931 83.0613 78.1487 82.9737 78.182C82.9197 78.2024 81.6486 78.6959 81.2886 79.9781C81.2631 80.0687 81.3162 80.1626 81.4068 80.1881C81.4218 80.1923 81.4371 80.1944 81.4524 80.1944Z",
    fill: "#EA5143"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M82.6168 79.6335C82.6486 79.6335 82.6804 79.6248 82.7089 79.6065C82.7881 79.5555 82.8109 79.4502 82.7599 79.371C82.7515 79.3578 82.5472 79.0464 82.1203 78.8556C82.0348 78.8169 81.9337 78.8556 81.8953 78.9414C81.8569 79.0272 81.8953 79.128 81.9811 79.1664C82.3114 79.314 82.4716 79.5531 82.4734 79.5555C82.5061 79.6062 82.561 79.6335 82.6168 79.6335Z",
    fill: "#EA5143"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M70.0238 77.6169C70.0238 77.6169 68.9162 76.14 68.0927 77.3613C67.2692 78.5823 68.4335 82.1892 70.4498 81.3087L70.0238 77.6169Z",
    fill: "#F97853"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M70.0095 80.1941C69.9351 80.1941 69.8667 80.1449 69.8454 80.0696C69.5331 78.956 68.3793 78.5045 68.3676 78.5003C68.2797 78.4667 68.2356 78.3683 68.2689 78.2807C68.3022 78.1928 68.4006 78.1484 68.4882 78.1817C68.5422 78.2021 69.8136 78.6956 70.1733 79.9778C70.1988 80.0684 70.146 80.1623 70.0551 80.1878C70.0401 80.192 70.0248 80.1941 70.0095 80.1941Z",
    fill: "#EA5143"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M68.8451 79.6333C68.8133 79.6333 68.7815 79.6246 68.753 79.6063C68.6738 79.5553 68.651 79.45 68.702 79.3708C68.7104 79.3576 68.9144 79.0462 69.3416 78.8554C69.4271 78.8167 69.5282 78.8554 69.5666 78.9412C69.605 79.027 69.5666 79.1278 69.4808 79.1662C69.1505 79.3138 68.99 79.5529 68.9885 79.5553C68.9561 79.606 68.9012 79.6333 68.8451 79.6333Z",
    fill: "#EA5143"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M73.0044 84.3682L73.0044 87.9549C73.0044 87.9549 74.0742 89.7816 75.5205 89.9058C76.9656 90.0318 78.2499 88.3332 78.2499 88.3332L78.2499 84.6202L73.0044 84.3682Z",
    fill: "#FFA681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M73.0044 84.3682L73.0044 85.9597C73.9749 87.0366 75.699 87.3057 78.2499 86.9293L78.2499 84.6205L73.0044 84.3682Z",
    fill: "#F97853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M69.2236 75.157C69.2893 76.5508 69.4219 78.2944 69.6883 79.687L69.6883 79.6909C69.6883 79.6948 69.6895 79.699 69.691 79.7044C69.691 79.7059 69.6922 79.7059 69.6922 79.7071C69.7579 80.0473 69.8314 80.3674 69.9118 80.6551C69.9601 80.8237 70.0123 81.0004 70.0711 81.1813C70.9213 83.8486 72.8911 87.7089 77.8415 85.9428C79.9262 85.1997 81.0122 83.0467 81.5654 80.7115C81.5975 80.5723 81.6284 80.4343 81.6551 80.3017C81.6737 80.2132 81.6914 80.1277 81.7073 80.0431L81.7313 79.9186C81.7352 79.8973 81.7379 79.8826 81.7394 79.873C81.7409 79.8676 81.7409 79.8649 81.7409 79.8649C82.0676 78.0694 82.1171 76.2535 82.0931 74.956C82.0676 73.633 81.3446 72.4225 80.1932 71.7706C77.0747 70.0018 73.7818 70.6618 71.614 71.4949C70.1086 72.0721 69.1459 73.549 69.2236 75.157Z",
    fill: "#FFA681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M69.687 79.687C69.687 79.687 69.687 79.6882 69.6882 79.6909C69.6882 79.6948 69.6894 79.699 69.6909 79.7044C69.6909 79.7059 69.6921 79.7059 69.6921 79.7071C69.7242 79.8235 69.8982 80.4622 70.071 81.1813C70.9212 83.8486 72.891 87.709 77.8414 85.9429C79.9261 85.1998 81.0121 83.0467 81.5653 80.7115C81.5974 80.5723 81.6283 80.4343 81.655 80.3017C81.6736 80.2132 81.6913 80.1277 81.7072 80.0431L81.7312 79.9186C81.7351 79.8973 81.7378 79.8826 81.7393 79.873C81.7408 79.8676 81.7408 79.8649 81.7408 79.8649L81.0124 79.7176C80.8732 80.4073 80.5651 81.0565 80.1874 81.6337C79.5715 80.158 76.4461 81.1384 76.4461 81.1384L76.4314 81.1438C76.2412 81.2026 76.0459 81.2335 75.8488 81.2335C75.6466 81.2335 75.4456 81.2014 75.2503 81.1384C75.2503 81.1384 72.1623 80.1154 71.5224 81.5227C70.8825 80.5318 70.4484 79.6333 70.4484 79.6333L69.6879 79.687L69.687 79.687ZM75.8413 81.8068C79.375 81.3301 78.8194 83.2327 78.8194 83.2327C78.427 83.5903 78.0682 83.8513 77.8273 83.9866C77.056 84.4165 76.2967 84.5797 75.7465 84.553C75.204 84.5302 75.0555 84.6415 73.6842 83.8996C73.4418 83.7697 73.1967 83.5768 72.957 83.3479C72.957 83.3479 72.957 83.3479 72.9558 83.3479L72.9558 83.3467C72.8967 82.9744 72.2982 81.1975 75.8413 81.8068Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M72.6392 77.7507C72.6392 78.1335 72.8366 78.444 73.0799 78.444C73.3232 78.444 73.5206 78.1335 73.5206 77.7507C73.5206 77.3679 73.3232 77.0574 73.0799 77.0574C72.8363 77.0574 72.6392 77.3679 72.6392 77.7507Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M78.1489 77.7507C78.1489 78.1335 78.3463 78.444 78.5896 78.444C78.8332 78.444 79.0303 78.1335 79.0303 77.7507C79.0303 77.3679 78.8329 77.0574 78.5896 77.0574C78.3463 77.0574 78.1489 77.3679 78.1489 77.7507Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M71.5105 75.4132C71.5105 75.4132 73.3318 74.6935 74.734 75.2992L74.5939 76.0792C74.5939 76.0792 72.5356 75.9052 71.4988 76.3252C71.4058 76.0252 71.392 75.7216 71.5105 75.4132Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M80.1706 75.4168C80.1706 75.4168 78.3357 74.6917 76.9233 75.3019L77.0646 76.0876C77.0646 76.0876 79.138 75.9121 80.1826 76.3357C80.2762 76.0333 80.2897 75.7276 80.1706 75.4168Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M75.6719 80.8493C75.3845 80.8493 75.0992 80.7374 75.0551 80.7194C74.9681 80.684 74.9264 80.5844 74.9618 80.4974C74.9972 80.4104 75.0968 80.3684 75.1838 80.4038C75.3377 80.4662 75.7073 80.5643 75.8672 80.4683C75.8981 80.4497 75.9404 80.4131 75.9509 80.3096C76.0124 79.7144 75.8495 77.72 75.848 77.6999C75.8402 77.606 75.9101 77.5238 76.004 77.516C76.0982 77.5082 76.1801 77.5781 76.1879 77.6717C76.1948 77.7551 76.355 79.718 76.2902 80.3444C76.2659 80.5802 76.142 80.7008 76.0424 80.7605C75.9335 80.8265 75.8024 80.8493 75.6719 80.8493Z",
    fill: "#F97853"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M77.8442 82.1475C77.7149 82.7985 77.2847 83.9957 75.8363 83.9957C74.3843 83.9957 73.9772 82.9017 73.8374 82.1475L77.8442 82.1475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M69.223 75.1564C69.2896 76.5502 69.4225 78.2935 69.6883 79.6873L70.45 79.6333C70.45 79.6333 70.2655 78.4564 70.1803 77.6896C70.0951 76.9228 69.9505 75.4894 70.6048 75.3106C71.2573 75.1336 70.8745 73.4983 71.7827 72.7894C72.6908 72.079 74.7224 71.884 76.0619 72.7087C77.4011 73.5316 78.9104 72.6463 79.5275 72.7894C80.1461 72.931 80.9843 73.7827 80.7578 74.5786C80.5295 75.3727 81.2111 75.8566 81.3764 76.6795C81.5417 77.5024 81.0134 79.7176 81.0134 79.7176L81.7409 79.8643C82.0682 78.0682 82.1174 76.2535 82.0937 74.9569C82.0682 73.633 81.3458 72.4231 80.1938 71.7706C77.0738 70.0018 73.7819 70.6612 71.6143 71.4946C70.1092 72.0724 69.1462 73.5496 69.223 75.1564Z",
    fill: "#403657"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M100.579 113.538C100.116 117.763 97.358 127.201 95.4482 129.049C92.9618 131.456 84.7792 136.524 80.5171 139.122C79.7482 139.59 83.3599 142.711 83.3599 142.711C83.3599 142.711 94.6766 137.872 98.9984 134.057C100.221 132.977 102.703 129.573 105.506 123.089C106.355 121.123 108.414 117.158 108.307 114.572C108.184 111.596 103.457 112.086 100.579 113.538Z",
    fill: "#7846D1"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M91.7486 137.806C91.7486 137.806 88.6705 138.974 87.5797 140.26C86.4889 141.546 85.0474 142.637 85.3978 143.143C85.7485 143.65 87.3457 142.169 87.3457 142.169C87.3457 142.169 87.7837 143.797 89.3327 143.972C90.8819 144.148 93.8132 141.117 93.8132 141.117L91.7486 137.806Z",
    fill: "#FFA681"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M122.131 125.333C122.132 125.601 122.13 125.917 122.125 126.275C122.12 126.632 122.112 127.031 122.102 127.466C122.093 127.765 122.084 128.08 122.073 128.411C122.063 128.69 122.052 128.979 122.04 129.279C122.027 129.586 122.013 129.901 121.997 130.227C121.783 134.651 121.265 140.76 120.126 145.657L96.1797 145.657C96.9783 142.098 98.2002 136.484 99.1695 129.2C99.21 128.894 99.2505 128.584 99.2904 128.272C99.3303 127.959 99.369 127.644 99.408 127.326C99.429 127.157 99.4494 126.986 99.4695 126.815C99.486 126.674 99.5022 126.534 99.5178 126.395C99.5622 126.003 99.6027 125.616 99.6387 125.237C99.669 124.921 99.6972 124.61 99.7236 124.303C100.134 119.406 99.9894 115.736 100.579 113.538C101.267 110.979 109.28 108.045 109.28 108.045L114.3 108.308C114.3 108.308 119.087 109.871 121.646 112.117C124.206 114.364 122.065 121.069 122.127 124.877C122.13 125.008 122.13 125.16 122.131 125.333Z",
    fill: "#9C78ED"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M122.125 126.276C119.948 126.54 117.676 126.644 115.448 126.644C108.149 126.644 101.297 125.529 99.6382 125.238C99.6685 124.921 99.6967 124.611 99.7231 124.304C101.651 124.645 112.807 126.49 122.131 125.334C122.132 125.601 122.13 125.917 122.125 126.276Z",
    fill: "#E0D5F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M122.102 127.466C122.093 127.765 122.084 128.08 122.073 128.411C119.911 128.671 117.659 128.773 115.448 128.773C107.737 128.773 100.525 127.528 99.4077 127.326C99.4287 127.157 99.4491 126.986 99.4692 126.816C99.4857 126.675 99.5019 126.534 99.5175 126.396C100.628 126.598 112.358 128.668 122.102 127.466Z",
    fill: "#E0D5F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M122.04 129.279C122.027 129.586 122.013 129.901 121.997 130.227C119.748 130.513 117.394 130.624 115.085 130.624C107.619 130.624 100.623 129.458 99.1694 129.2C99.2099 128.894 99.2504 128.584 99.2903 128.272C101.018 128.58 112.542 130.522 122.04 129.279Z",
    fill: "#E0D5F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M110.728 112.862C113.224 112.862 115.527 110.208 115.627 110.092C115.69 110.018 115.682 109.907 115.608 109.843C115.534 109.78 115.423 109.788 115.359 109.862C115.335 109.89 112.923 112.669 110.513 112.502C110.417 112.495 110.332 112.568 110.325 112.665C110.318 112.762 110.391 112.846 110.489 112.853C110.568 112.859 110.649 112.862 110.728 112.862Z",
    fill: "#7846D1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M112.892 142.702C112.98 142.702 113.057 142.635 113.067 142.546C113.078 142.449 113.009 142.362 112.912 142.35C106.464 141.608 103.793 130.447 103.766 130.334C103.744 130.239 103.65 130.18 103.555 130.202C103.46 130.225 103.401 130.319 103.423 130.414C103.533 130.884 106.179 141.93 112.872 142.701C112.879 142.701 112.886 142.702 112.892 142.702Z",
    fill: "#7846D1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M110.325 139.324C110.384 139.324 110.441 139.295 110.475 139.241C110.526 139.158 110.5 139.049 110.417 138.998C106.988 136.884 106.478 133.767 106.473 133.736C106.458 133.64 106.369 133.573 106.272 133.588C106.176 133.603 106.11 133.692 106.125 133.788C106.145 133.922 106.657 137.094 110.232 139.298C110.261 139.316 110.293 139.324 110.325 139.324Z",
    fill: "#7846D1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M112.327 103.507C116.228 103.507 119.391 100.344 119.391 96.4427C119.391 92.5414 116.228 89.3787 112.327 89.3787C108.425 89.3787 105.263 92.5414 105.263 96.4427C105.263 100.344 108.425 103.507 112.327 103.507Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M105.378 95.1761C105.378 95.1761 103.378 94.6238 103.642 92.6822C103.866 91.0298 105.807 92.1011 105.637 90.8096C105.466 89.5181 105.087 88.3439 106.757 88.0211C108.219 87.7388 108.243 88.7402 110.162 87.2873C112.43 85.5711 114.171 89.5454 116.195 89.6648C119.179 89.8409 119.556 91.5287 119.849 92.879C120.143 94.2293 118.994 95.1761 118.994 95.1761L105.378 95.1761Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M106.45 98.4194C106.45 98.4194 105.331 96.9275 104.499 98.1611C103.667 99.3947 104.843 103.038 106.88 102.149L106.45 98.4194Z",
    fill: "#F97853"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M106.435 101.023C106.36 101.023 106.291 100.973 106.27 100.897C105.954 99.7723 104.789 99.3163 104.777 99.3118C104.688 99.2779 104.643 99.1786 104.677 99.0898C104.711 99.001 104.81 98.9563 104.899 98.9899C104.954 99.0106 106.238 99.5089 106.602 100.804C106.627 100.896 106.574 100.991 106.482 101.017C106.466 101.021 106.451 101.023 106.435 101.023Z",
    fill: "#EA5143"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M105.258 100.456C105.226 100.456 105.194 100.448 105.165 100.429C105.085 100.378 105.063 100.271 105.114 100.191C105.123 100.178 105.329 99.8633 105.76 99.6704C105.846 99.6314 105.949 99.6704 105.987 99.7571C106.026 99.8438 105.987 99.9458 105.901 99.9845C105.567 100.134 105.405 100.375 105.404 100.378C105.371 100.429 105.315 100.456 105.258 100.456Z",
    fill: "#EA5143"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M114.565 105.24L114.565 108.864C114.565 108.864 113.076 110.461 111.614 110.586C110.154 110.713 109.266 108.979 109.266 108.979L109.266 105.495L114.565 105.24Z",
    fill: "#FFA681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M114.565 105.24L114.565 106.848C113.584 107.936 111.843 108.208 109.266 107.827L109.266 105.495L114.565 105.24Z",
    fill: "#F97853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M118.386 95.9335C118.319 97.3417 118.184 99.1027 117.916 100.511C117.849 100.862 117.773 101.193 117.688 101.489C116.926 104.159 115.018 108.737 109.679 106.83C107.32 105.989 106.227 103.361 105.74 100.69C105.409 98.8756 105.36 97.0423 105.384 95.7322C105.409 94.3949 106.139 93.1727 107.303 92.5133C110.455 90.7265 113.781 91.3925 115.971 92.2343C117.491 92.8178 118.463 94.3103 118.386 95.9335Z",
    fill: "#FFA681"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M111.979 98.4931L111.979 98.779C111.979 99.3547 112.204 99.895 112.612 100.301C113.015 100.701 113.547 100.92 114.112 100.92L114.182 100.92C114.672 100.91 115.118 100.712 115.509 100.333C115.901 99.9505 116.126 99.4039 116.126 98.8312L116.126 98.4934C116.126 98.3998 116.108 98.3104 116.076 98.2273C116.038 98.1265 115.98 98.0371 115.905 97.9624C115.769 97.8262 115.582 97.7422 115.374 97.7422L112.731 97.7422C112.432 97.7422 112.174 97.9168 112.054 98.1703C112.009 98.2627 111.983 98.3656 111.981 98.4736C111.979 98.4796 111.979 98.4871 111.979 98.4931ZM112.291 98.4931C112.291 98.2501 112.489 98.0536 112.731 98.0536L115.374 98.0536C115.617 98.0536 115.814 98.2501 115.814 98.4931L115.814 98.8309C115.814 99.3193 115.623 99.7861 115.291 100.109C114.959 100.431 114.584 100.599 114.176 100.608L114.112 100.608C113.63 100.608 113.176 100.421 112.831 100.079C112.483 99.733 112.291 99.2716 112.291 98.779L112.291 98.4931Z",
    fill: "#403657"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M106.688 98.4928L106.688 98.7787C106.688 99.3544 106.913 99.8947 107.321 100.3C107.723 100.701 108.255 100.92 108.82 100.92L108.891 100.92C109.38 100.909 109.827 100.712 110.217 100.333C110.609 99.9502 110.834 99.4036 110.834 98.8309L110.834 98.4931C110.834 98.488 110.834 98.4838 110.833 98.4787C110.832 98.377 110.809 98.2792 110.77 98.1907C110.654 97.9258 110.39 97.7419 110.083 97.7419L107.439 97.7419C107.207 97.7419 107 97.8478 106.861 98.0131C106.795 98.0941 106.744 98.1889 106.717 98.2915C106.697 98.3557 106.688 98.4232 106.688 98.4928ZM107 98.4928C107 98.2498 107.197 98.0533 107.439 98.0533L110.083 98.0533C110.325 98.0533 110.522 98.2498 110.522 98.4928L110.522 98.8306C110.522 99.319 110.331 99.7858 110 100.109C109.668 100.431 109.293 100.599 108.885 100.608L108.82 100.608C108.338 100.608 107.884 100.421 107.541 100.079C107.192 99.7327 106.999 99.2713 106.999 98.7787L106.999 98.4928L107 98.4928Z",
    fill: "#403657"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M118.009 97.6157C117.111 97.577 116.47 97.8359 116.217 97.9622C116.146 97.9964 115.957 98.1194 115.949 98.1245L116.097 98.3891C116.099 98.3879 116.306 98.2646 116.387 98.2271C116.636 98.111 117.188 97.8782 118.009 97.9265L118.009 97.6157Z",
    fill: "#403657"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M112.189 98.5047L112.291 98.2101C112.273 98.2038 111.835 98.0532 111.354 98.0532C110.843 98.0532 110.513 98.2104 110.499 98.217L110.635 98.4975C110.638 98.4963 110.919 98.3649 111.354 98.3649C111.781 98.3652 112.185 98.5035 112.189 98.5047Z",
    fill: "#403657"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M105.596 97.6907L105.596 98.0033C106.241 98.0567 106.838 98.345 106.846 98.3486L106.984 98.069C106.948 98.0513 106.308 97.7426 105.596 97.6907Z",
    fill: "#403657"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M109.134 98.8926C109.134 99.2793 108.935 99.5931 108.689 99.5931C108.443 99.5931 108.244 99.2796 108.244 98.8926C108.244 98.5059 108.443 98.1921 108.689 98.1921C108.935 98.1921 109.134 98.5056 109.134 98.8926Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M114.348 98.8926C114.348 99.2793 114.148 99.5931 113.903 99.5931C113.657 99.5931 113.458 99.2796 113.458 98.8926C113.458 98.5059 113.657 98.1921 113.903 98.1921C114.149 98.1921 114.348 98.5056 114.348 98.8926Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M107.24 96.7415C107.24 96.7415 109.094 96.0089 110.521 96.6257L110.402 97.2881C110.402 97.2881 108.856 96.9431 107.343 97.5074C107.248 97.202 107.12 97.0556 107.24 96.7415Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M115.722 96.7415C115.722 96.7415 113.869 96.0089 112.441 96.6257L112.561 97.2881C112.561 97.2881 114.106 96.9431 115.62 97.5074C115.714 97.202 115.843 97.0556 115.722 96.7415Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M111.569 101.828C111.86 101.828 112.148 101.715 112.192 101.697C112.28 101.661 112.322 101.56 112.287 101.472C112.251 101.384 112.15 101.342 112.062 101.378C111.907 101.441 111.534 101.54 111.372 101.443C111.34 101.424 111.298 101.387 111.287 101.283C111.225 100.681 111.389 98.6667 111.391 98.6463C111.399 98.5515 111.328 98.4684 111.234 98.4606C111.139 98.4525 111.056 98.5233 111.048 98.6181C111.041 98.7024 110.879 100.685 110.945 101.318C110.969 101.556 111.094 101.678 111.195 101.738C111.305 101.804 111.438 101.828 111.569 101.828Z",
    fill: "#F97853"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M109.435 102.702C109.576 103.409 110.043 104.712 111.619 104.712C113.198 104.712 113.641 103.522 113.793 102.702L109.435 102.702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M111.598 105.61C112.043 105.61 112.421 105.385 112.437 105.375C112.518 105.326 112.544 105.22 112.495 105.139C112.445 105.057 112.34 105.032 112.258 105.081C112.256 105.083 111.944 105.266 111.597 105.266C111.279 105.266 110.974 105.083 110.971 105.081C110.89 105.031 110.784 105.056 110.734 105.137C110.684 105.218 110.709 105.324 110.79 105.374C110.806 105.384 111.177 105.61 111.598 105.61Z",
    fill: "#F97853"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M106.273 99.5679C106.143 98.8581 106.014 97.9416 106.108 97.4721C106.276 96.6408 106.964 96.1521 106.734 95.3508C106.505 94.5462 107.352 93.6849 107.977 93.5421C108.599 93.3975 110.057 93.708 111.492 93.0267C112.862 92.3757 115.242 92.8413 115.63 93.7203C116.1 94.7844 115.461 94.8849 116.742 96.0357C117.252 96.4944 116.647 97.6857 116.56 98.4603C116.522 98.8167 116.516 98.9907 116.53 99.3735L116.535 99.5679L118.068 99.5679C118.237 98.3664 118.334 97.0416 118.387 95.9331C118.464 94.3095 117.49 92.8185 115.971 92.2344C113.781 91.3926 110.456 90.7257 107.302 92.5131C106.14 93.1731 105.409 94.3941 105.384 95.7318C105.365 96.7707 105.392 98.1396 105.57 99.5676L106.273 99.5676L106.273 99.5679Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M117.388 100.23C117.383 99.829 117.412 99.4279 117.482 99.0331C117.578 98.4931 117.734 98.0029 118.287 97.7779C118.732 97.5967 119.207 97.5931 119.544 98.0944C120.376 99.328 119.45 103.167 117.413 102.278L117.388 100.23Z",
    fill: "#FFA681"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M117.807 101.16C117.88 101.145 117.938 101.083 117.945 101.004C118.034 99.8391 119.088 99.1638 119.098 99.1569C119.179 99.1062 119.203 99 119.152 98.9196C119.102 98.8392 118.996 98.8146 118.915 98.865C118.866 98.8959 117.704 99.636 117.601 100.978C117.594 101.072 117.665 101.155 117.76 101.162C117.776 101.164 117.792 101.162 117.807 101.16Z",
    fill: "#F97853"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M118.849 100.374C118.881 100.367 118.91 100.352 118.935 100.329C119.003 100.263 119.005 100.153 118.939 100.085C118.928 100.074 118.664 99.8056 118.203 99.7009C118.111 99.6796 118.019 99.7378 117.998 99.8305C117.976 99.9232 118.034 100.015 118.127 100.037C118.484 100.118 118.69 100.323 118.692 100.325C118.734 100.368 118.794 100.385 118.849 100.374Z",
    fill: "#F97853"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M120.627 111.332C118.112 115.145 108.483 128.329 106.31 129.86C103.482 131.854 95.7722 134.689 91.3457 137.644C89.8418 138.649 93.395 141.491 93.395 141.491C93.395 141.491 104.185 138.457 109.044 135.355C110.419 134.478 116.136 128.751 119.782 123.671C121.031 121.93 123.062 119.513 123.356 116.943C123.694 113.984 122.765 112.401 120.627 111.332Z",
    fill: "#7846D1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M101.544 145.658L71.5482 145.658C71.1648 145.658 70.854 145.347 70.854 144.963L70.854 142.573C70.854 142.19 71.1648 141.879 71.5482 141.879L101.544 141.879C101.927 141.879 102.238 142.19 102.238 142.573L102.238 144.963C102.238 145.347 101.927 145.658 101.544 145.658Z",
    fill: "#1A0B42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M70.8607 145.658L64.9617 123.566C64.6305 122.325 65.5656 121.108 66.8499 121.108L79.8304 121.108C80.7061 121.108 81.475 121.69 81.712 122.534L88.2077 145.658L70.8607 145.658Z",
    fill: "#403657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M81.7123 122.534L88.1539 145.467L89.6371 145.467L83.1955 122.534C82.957 121.69 82.1893 121.107 81.3133 121.107L79.8301 121.107C80.7061 121.107 81.4738 121.69 81.7123 122.534Z",
    fill: "#1A0B42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M78.3754 134.372C78.7126 135.829 77.8048 137.01 76.3477 137.01C74.8906 137.01 73.4359 135.829 73.0987 134.372C72.7614 132.915 73.6693 131.733 75.1264 131.733C76.5835 131.733 78.0382 132.915 78.3754 134.372Z",
    fill: "#614C6E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M118.599 64.2904C117.506 64.2904 116.618 63.4018 116.618 62.3095C116.618 61.2172 117.506 60.3286 118.599 60.3286C119.691 60.3286 120.579 61.2172 120.579 62.3095C120.579 63.4018 119.691 64.2904 118.599 64.2904ZM118.599 60.9496C117.849 60.9496 117.239 61.5595 117.239 62.3092C117.239 63.0589 117.849 63.6688 118.599 63.6688C119.348 63.6688 119.958 63.0589 119.958 62.3092C119.958 61.5595 119.348 60.9496 118.599 60.9496Z",
    fill: "#7846D1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M125.73 71.2401C124.638 71.2401 123.749 70.3515 123.749 69.2592C123.749 68.1669 124.638 67.2783 125.73 67.2783C126.822 67.2783 127.711 68.1669 127.711 69.2592C127.711 70.3515 126.822 71.2401 125.73 71.2401ZM125.73 67.8996C124.98 67.8996 124.37 68.5095 124.37 69.2592C124.37 70.0089 124.98 70.6188 125.73 70.6188C126.48 70.6188 127.09 70.0089 127.09 69.2592C127.09 68.5095 126.48 67.8996 125.73 67.8996Z",
    fill: "#9C78ED"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M128.178 77.6775C128.006 77.6775 127.867 77.5383 127.867 77.3667L127.867 75.9963C127.867 75.8247 128.006 75.6855 128.178 75.6855C128.35 75.6855 128.489 75.8247 128.489 75.9963L128.489 77.3667C128.488 77.5383 128.35 77.6775 128.178 77.6775Z",
    fill: "#7846D1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M128.178 80.0755C128.006 80.0755 127.867 79.9363 127.867 79.7647L127.867 78.3943C127.867 78.2227 128.006 78.0835 128.178 78.0835C128.35 78.0835 128.489 78.2227 128.489 78.3943L128.489 79.7647C128.488 79.9366 128.35 80.0755 128.178 80.0755Z",
    fill: "#7846D1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M130.101 78.1914L128.87 78.1914C128.699 78.1914 128.56 78.0522 128.56 77.8806C128.56 77.709 128.699 77.5698 128.87 77.5698L130.101 77.5698C130.273 77.5698 130.412 77.709 130.412 77.8806C130.412 78.0522 130.273 78.1914 130.101 78.1914Z",
    fill: "#7846D1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M127.485 78.1914L126.254 78.1914C126.083 78.1914 125.943 78.0522 125.943 77.8806C125.943 77.709 126.083 77.5698 126.254 77.5698L127.485 77.5698C127.657 77.5698 127.796 77.709 127.796 77.8806C127.796 78.0522 127.657 78.1914 127.485 78.1914Z",
    fill: "#7846D1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M117.239 69.9988C117.067 69.9988 116.928 69.8596 116.928 69.688L116.928 68.3176C116.928 68.146 117.067 68.0068 117.239 68.0068C117.411 68.0068 117.55 68.146 117.55 68.3176L117.55 69.688C117.55 69.8596 117.411 69.9988 117.239 69.9988Z",
    fill: "#5B23A9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M117.239 72.397C117.067 72.397 116.928 72.2578 116.928 72.0862L116.928 70.7158C116.928 70.5442 117.067 70.405 117.239 70.405C117.411 70.405 117.55 70.5442 117.55 70.7158L117.55 72.0862C117.55 72.2578 117.411 72.397 117.239 72.397Z",
    fill: "#5B23A9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M119.163 70.5127L117.932 70.5127C117.76 70.5127 117.621 70.3735 117.621 70.2019C117.621 70.0303 117.76 69.8911 117.932 69.8911L119.163 69.8911C119.334 69.8911 119.474 70.0303 119.474 70.2019C119.473 70.3735 119.334 70.5127 119.163 70.5127Z",
    fill: "#5B23A9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M116.547 70.5127L115.316 70.5127C115.144 70.5127 115.005 70.3735 115.005 70.2019C115.005 70.0303 115.144 69.8911 115.316 69.8911L116.547 69.8911C116.718 69.8911 116.857 70.0303 116.857 70.2019C116.857 70.3735 116.718 70.5127 116.547 70.5127Z",
    fill: "#5B23A9"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M26.6631 55.195C26.6631 54.1027 27.5517 53.2141 28.644 53.2141C29.7363 53.2141 30.6249 54.1027 30.6249 55.195C30.6249 56.2873 29.7363 57.1759 28.644 57.1759C27.5517 57.1762 26.6631 56.2873 26.6631 55.195ZM27.2847 55.195C27.2847 55.9447 27.8946 56.5546 28.6443 56.5546C29.394 56.5546 30.0039 55.9447 30.0039 55.195C30.0039 54.4453 29.394 53.8354 28.6443 53.8354C27.8946 53.8354 27.2847 54.4453 27.2847 55.195Z",
    fill: "#7846D1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M18.7075 62.7461C18.7075 61.6538 19.5961 60.7649 20.6884 60.7649C21.7807 60.7649 22.6693 61.6535 22.6693 62.7461C22.6693 63.8387 21.7807 64.727 20.6884 64.727C19.5961 64.727 18.7075 63.8384 18.7075 62.7461ZM19.3288 62.7461C19.3288 63.4958 19.9387 64.1057 20.6884 64.1057C21.4381 64.1057 22.048 63.4958 22.048 62.7461C22.048 61.9964 21.4381 61.3865 20.6884 61.3865C19.9387 61.3865 19.3288 61.9964 19.3288 62.7461Z",
    fill: "#9C78ED"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M14.5891 65.5259C14.7607 65.5259 14.8999 65.3867 14.8999 65.2151L14.8999 63.8447C14.8999 63.6731 14.7607 63.5339 14.5891 63.5339C14.4175 63.5339 14.2783 63.6731 14.2783 63.8447L14.2783 65.2151C14.2783 65.3867 14.4175 65.5259 14.5891 65.5259Z",
    fill: "#7846D1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M14.5891 67.9241C14.7607 67.9241 14.8999 67.7849 14.8999 67.6133L14.8999 66.2429C14.8999 66.0713 14.7607 65.9321 14.5891 65.9321C14.4175 65.9321 14.2783 66.0713 14.2783 66.2429L14.2783 67.6133C14.2783 67.7849 14.4175 67.9241 14.5891 67.9241Z",
    fill: "#7846D1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M12.6658 66.0398L13.8967 66.0398C14.0683 66.0398 14.2075 65.9006 14.2075 65.729C14.2075 65.5574 14.0683 65.4182 13.8967 65.4182L12.6658 65.4182C12.4942 65.4182 12.355 65.5574 12.355 65.729C12.355 65.9006 12.4942 66.0398 12.6658 66.0398Z",
    fill: "#7846D1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M15.282 66.0398L16.5129 66.0398C16.6845 66.0398 16.8237 65.9006 16.8237 65.729C16.8237 65.5574 16.6845 65.4182 16.5129 65.4182L15.282 65.4182C15.1104 65.4182 14.9712 65.5574 14.9712 65.729C14.9712 65.9006 15.1104 66.0398 15.282 66.0398Z",
    fill: "#7846D1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M21.7493 54.992C21.9209 54.992 22.0601 54.8528 22.0601 54.6812L22.0601 53.3108C22.0601 53.1392 21.9209 53 21.7493 53C21.5777 53 21.4385 53.1392 21.4385 53.3108L21.4385 54.6812C21.4388 54.8528 21.578 54.992 21.7493 54.992Z",
    fill: "#5B23A9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M21.7493 57.3902C21.9209 57.3902 22.0601 57.251 22.0601 57.0794L22.0601 55.709C22.0601 55.5374 21.9209 55.3982 21.7493 55.3982C21.5777 55.3982 21.4385 55.5374 21.4385 55.709L21.4385 57.0794C21.4388 57.251 21.578 57.3902 21.7493 57.3902Z",
    fill: "#5B23A9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M19.8259 55.5059L21.0568 55.5059C21.2284 55.5059 21.3676 55.3667 21.3676 55.1951C21.3676 55.0235 21.2284 54.8843 21.0568 54.8843L19.8259 54.8843C19.6543 54.8843 19.5151 55.0235 19.5151 55.1951C19.5151 55.3667 19.6543 55.5059 19.8259 55.5059Z",
    fill: "#5B23A9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M22.4421 55.5059L23.6731 55.5059C23.8447 55.5059 23.9839 55.3667 23.9839 55.1951C23.9839 55.0235 23.8447 54.8843 23.6731 54.8843L22.4421 54.8843C22.2705 54.8843 22.1313 55.0235 22.1313 55.1951C22.1313 55.3667 22.2705 55.5059 22.4421 55.5059Z",
    fill: "#5B23A9"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M103.083 57.2985L103.083 63.3306C103.083 64.128 102.436 64.7748 101.639 64.7748L90.6862 64.7748L87.3796 65.9609C87.04 66.083 86.7151 65.7491 86.8453 65.4131L88.096 62.1831L88.096 57.2982C88.096 56.5008 88.7428 55.854 89.5408 55.854L101.639 55.854C102.436 55.854 103.083 56.5011 103.083 57.2985Z",
    fill: "#9C78ED"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M100.774 59.0049L90.7263 59.0049C90.5061 59.0049 90.3276 58.8264 90.3276 58.6062C90.3276 58.386 90.5061 58.2078 90.7263 58.2078L100.774 58.2078C100.995 58.2078 101.173 58.3863 101.173 58.6062C101.173 58.8267 100.995 59.0049 100.774 59.0049Z",
    fill: "#E0D5F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M100.774 60.6101L90.7263 60.6101C90.5061 60.6101 90.3276 60.4316 90.3276 60.2114C90.3276 59.9912 90.5061 59.813 90.7263 59.813L100.774 59.813C100.995 59.813 101.173 59.9915 101.173 60.2114C101.173 60.4316 100.995 60.6101 100.774 60.6101Z",
    fill: "#E0D5F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M100.774 62.2151L90.7263 62.2151C90.5061 62.2151 90.3276 62.0366 90.3276 61.8167C90.3276 61.5965 90.5061 61.418 90.7263 61.418L100.774 61.418C100.995 61.418 101.173 61.5965 101.173 61.8167C101.173 62.0366 100.995 62.2151 100.774 62.2151Z",
    fill: "#E0D5F8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M135.391 147.914L135.391 148.129C135.391 149.373 134.383 150.381 133.138 150.381L16.308 150.381C15.0639 150.381 14.0562 149.373 14.0562 148.129L14.0562 147.914C14.0562 146.67 15.0639 145.662 16.308 145.662L133.138 145.662C134.383 145.662 135.391 146.67 135.391 147.914Z",
    fill: "#5B23A9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M135.391 147.914L135.391 148.021L14.0562 148.021L14.0562 147.914C14.0562 146.67 15.0639 145.662 16.308 145.662L133.138 145.662C134.383 145.662 135.391 146.67 135.391 147.914Z",
    fill: "#7846D1"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_9158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/AboutUs.cefbd1d3e2ebe91c32cc06de0c68ab58.svg";
export { ForwardRef as ReactComponent };